/**
 * Constantes économiques du programme ambassadeur (source de vérité partagée).
 *
 * ⚠️ Fichier VOLONTAIREMENT PUR : aucun import (surtout pas `@sinclair/typebox`).
 * Les manifestes de features (`feature-manifest/`) les consomment pour rédiger la
 * doc utilisateur, et `packages/docs-site` exécute `generate:user-docs` avec son
 * PROPRE `node_modules` (installé par `npm ci` dans `packages/docs-site`, sans les
 * dépendances de `@cfixe/shared`). Importer ces valeurs depuis `lib/affiliate.ts`
 * tirait tout le module — donc typebox — et cassait le job CI `build-docs`.
 *
 * `lib/affiliate.ts` les ré-exporte : les consommateurs existants (backend,
 * frontends) continuent d'importer depuis `@cfixe/shared` sans changement.
 */

/** Commission : 30 % la 1ʳᵉ année (mois 1-12). */
export const AFFILIATE_RATE_YEAR_1_PERCENT = 30;
/** Commission : 10 % en années 2-3 (mois 13-36). */
export const AFFILIATE_RATE_YEAR_2_3_PERCENT = 10;
/** Fenêtre de commission : 36 mois par filleul depuis `referred_at`. */
export const AFFILIATE_WINDOW_MONTHS = 36;
/** Bascule 30 % → 10 % après le 12ᵉ mois de relation. */
export const AFFILIATE_RATE_SWITCH_MONTH = 12;
/** Bounty filleul : 20 € de réduction à l'inscription (centimes). */
export const AFFILIATE_BOUNTY_MINOR = 2000;
/** Seuil de demande de retrait : 50 € de solde cumulé (centimes). */
export const AFFILIATE_PAYOUT_THRESHOLD_MINOR = 5000;
